module.exports = __webpack_public_path__ + "static/img/stay-option-icon-bathtub.f688b4f8.svg";